import { render } from "./TdmRecomRes.vue?vue&type=template&id=180590dc&scoped=true&ts=true"
import script from "./TdmRecomRes.vue?vue&type=script&lang=ts"
export * from "./TdmRecomRes.vue?vue&type=script&lang=ts"

import "./TdmRecomRes.vue?vue&type=style&index=0&id=180590dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180590dc"]])

export default __exports__